import script from "./FormTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./FormTextarea.vue?vue&type=style&index=0&id=64ba9c41&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ba9c41"]])

export default __exports__